var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spreadsheet-preview-wrapper position-relative"},[(_vm.loading)?_c('div',{staticClass:"spreadsheet-loading-overlay"}):_vm._e(),_c('div',{ref:"sheetContainer",staticClass:"spreadsheet-mount-point"})])}
var staticRenderFns = []

export { render, staticRenderFns }